import { render, staticRenderFns } from "./EquipmentsView.vue?vue&type=template&id=37b67a78&scoped=true"
import script from "./EquipmentsView.vue?vue&type=script&lang=js"
export * from "./EquipmentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b67a78",
  null
  
)

export default component.exports